
import React, { useState, useEffect } from 'react';

export const HeartbeatVisualization = () => {
  const [points, setPoints] = useState([]);
  const [offset, setOffset] = useState(0);
  
  // Crée un battement cardiaque réaliste
  const generateHeartbeat = (startX) => {
    const segment = [];
    // Ligne de base
    for (let i = 0; i < 20; i++) {
      segment.push({
        x: startX + i,
        y: 50
      });
    }
    
    // Onde P (petite bosse)
    segment.push({ x: startX + 21, y: 45 });
    segment.push({ x: startX + 22, y: 35 });
    segment.push({ x: startX + 23, y: 45 });
    
    // Retour à la ligne de base
    segment.push({ x: startX + 24, y: 50 });
    segment.push({ x: startX + 25, y: 50 });
    
    // Complexe QRS (grand pic)
    segment.push({ x: startX + 26, y: 55 }); // Q
    segment.push({ x: startX + 27, y: 10 }); // R
    segment.push({ x: startX + 28, y: 90 }); // S
    segment.push({ x: startX + 29, y: 50 });
    
    // Onde T (bosse moyenne)
    segment.push({ x: startX + 35, y: 40 });
    segment.push({ x: startX + 37, y: 30 });
    segment.push({ x: startX + 39, y: 40 });
    
    // Retour à la ligne de base
    for (let i = 0; i < 10; i++) {
      segment.push({
        x: startX + 40 + i,
        y: 50
      });
    }
    
    return segment;
  };
  
  useEffect(() => {
    // Génère plusieurs battements de cœur pour remplir l'écran
    let allPoints = [];
    for (let i = 0; i < 6; i++) {
      allPoints = [...allPoints, ...generateHeartbeat(i * 50)];
    }
    setPoints(allPoints);
    
    // Animation du rythme cardiaque avec vitesse améliorée
    const timer = setInterval(() => {
      setOffset(prev => (prev + 1.5) % 50);
    }, 40);
    
    return () => clearInterval(timer);
  }, []);
  
  // Transforme les points en chaîne de caractères pour le SVG
  const getPath = () => {
    if (points.length === 0) return '';
    
    const adjustedPoints = points.map(p => ({
      x: p.x - offset,
      y: p.y
    }));
    
    let d = `M ${adjustedPoints[0].x} ${adjustedPoints[0].y}`;
    for (let i = 1; i < adjustedPoints.length; i++) {
      d += ` L ${adjustedPoints[i].x} ${adjustedPoints[i].y}`;
    }
    return d;
  };

  // Couleur plus subtile pour l'aspect professionnel 
  const strokeColor = "#ff3a4c";
  // Ligne plus fine pour un aspect professionnel
  const strokeWidth = 1;
  
  return (
    <div className="w-full h-24 flex items-center justify-center bg-transparent">
      <svg className="w-full h-full" viewBox="0 0 250 100" preserveAspectRatio="none">
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={strokeColor} stopOpacity="0.1" />
            <stop offset="50%" stopColor={strokeColor} stopOpacity="0.5" />
            <stop offset="100%" stopColor={strokeColor} stopOpacity="0.1" />
          </linearGradient>
          <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="1.5" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>
        <path
          d={getPath()}
          stroke="url(#lineGradient)"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          filter="url(#glow)"
        />
      </svg>
    </div>
  );
};
